import EventEmitter from 'events';

const user = 'userInfo';

class DataLocal extends EventEmitter {
    UserData() {
        return JSON.parse(localStorage.getItem(user));
    };

    IsCommandCenter() {
        let tmp = JSON.parse(localStorage.getItem(user))
        return tmp.fleet_group.levels == '1'
    }
}

export default new DataLocal();
